<template>
    <div class="form-group">
        <label>{{index}}</label>
        <div v-if="typeof componentItem !== 'string'">
            <template v-for="(content, i) in componentItem">
                <div :key="`${i}`">
                    <div v-if="typeof content !== 'object'" >
                        <div class="form-group">
                            <label>{{ i }}</label>
                            <ImageUploader v-if="isImageField(i)" :size="getImageSize(i)" :forTemplate="'sponsorLogo'" :imageFieldKey="i" :imageFieldObject="componentItem" ></ImageUploader>
                            <input v-else-if="isUrlInupt(sampleContent[index][i])" v-bind:class="{invalid : !isUrlInupt(componentItem[i])}" type="text" class="form-control" :id="i" v-model="componentItem[i]" >
                            <input v-else type="text" class="form-control" :id="i" v-model="componentItem[i]" >
                        </div>
                    </div>

                    <div v-else>
                        <Repeater
                            v-if="template"
                            :itemArray="componentItem"
                            :itemField="i"
                            :template="template"
                        />
                    </div>

                </div>
            </template>
        </div>

        <div v-else>
            <div class="form-group">
                <label>{{index}}</label>
                <input v-if="isUrlInupt(sampleContent[index])" type="text" class="form-control" v-bind:class="{invalid : !isUrlInupt(contentClone[index])}" v-model="contentClone[index]" >
                <input v-else type="text" class="form-control" v-model="contentClone[index]" >
            </div>
        </div>

    </div>
</template>

<script>
    import Repeater from './Repeater';
    import ImageUploader from './ImageUploader';

	export default {

        components: {
            Repeater,
            ImageUploader
        },
		
		name: 'About',
        
        props: ['componentItem', 'index', 'contentClone', 'sampleContent'],

        data() {
            return {
                template: '',
                repeaterField: 'links',
                isUrl: false
            }
        },

        mounted() {
            if(this.index === 'mainMenu') {
                this.template = this.getTemplate();
            }
        },

        methods: {

            isImageField(field){
                return (field == "image" || field == "logo" || field == "twitter-image" || field == "content-image")
            },
            isUrlInupt(string){
                if(string !== undefined && typeof string === "string"){
                    var expression = "^(http|https)://";
                    var regex = new RegExp(expression, "i");

                    if(string.match(regex)){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }

            },
            getImageSize(field){
                var type = "";
                switch(field){
                    case "image":
                        type = "social"
                    break
                    case "logo":
                        type = "sponsor"
                    break;
                    case "twitter-image":
                        type = "twitter-image"
                    break;
                }
                return type;
            },

            getTemplate() {
                return JSON.parse(JSON.stringify(
                            this.sampleContent['mainMenu'][this.repeaterField][0]
                        ));
            }

        }

    }
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}
    .invalid{
        background-color: rgba($color: #ff0000, $alpha: 0.6);
    }
	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>